import { Component } from "react";
import '../Components/Cards.scss';

class Cards extends Component {
    state = {
        firstCount: 0,
        secondCount:0,
        TotalPrice: 0,
    }


    AddCart = (id, price) => {
        if(id===1){
            this.setState({
                firstCount: this.state.firstCount + 1,
                TotalPrice: this.state.TotalPrice + price,
            });
        }else if(id===2){
            this.setState({
                secondCount: this.state.secondCount + 1,
                TotalPrice: this.state.TotalPrice + price,
            });
        }
        
    }


    render() {

        //Add to cart by using arrow functions
     
        //removeing from cart by using arrow functions
        const RemoveCart = (id, price) => {
            if(id===1 && this.state.firstCount>=1){
                this.setState({
                    firstCount: this.state.firstCount - 1,
                    TotalPrice: this.state.TotalPrice - price,
                });
            }else if(id===2 && this.state.secondCount>=1){
                this.setState({
                    secondCount: this.state.secondCount - 1,
                    TotalPrice: this.state.TotalPrice - price,
                });
            }
        }

        return (
            <>
                <h1 className="heading">Dairy, Bread & Eggs</h1>
                <div className='cards_Section'>

                    <div className='cards'>
                        <img className='w-100' src='https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/assets/products/sliding_images/jpeg/2611ae97-7654-4ca6-b726-ac1c23ff006a.jpg?ts=1712325585' alt="Milk" />
                        <div className="description">
                            <p>Heritage Daily Health Toned Fresh Milk</p>
                            <div className="price_button">
                                <div className="price">₹30</div>
                                <div className="buttons">
                                    <button className="button-1" onClick={() => RemoveCart(1, 30)}>-</button>
                                    <span>{this.state.firstCount}</span>
                                    <button className="button-2" onClick={() => this.AddCart(1, 30)}>+</button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='cards'>
                        <img className='w-100' src='https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=270/app/images/products/sliding_image/342271a.jpg?ts=1687525111' alt="Curd" />
                        <div className="description">
                            <p>Godrej Jersey Curd</p>
                            <div className="price_button">
                                <div className="price">₹50</div>
                                <div className="buttons">
                                    <button className="button-1" onClick={() => RemoveCart(2, 50)}>-</button>
                                    <span>{this.state.secondCount}</span>
                                    <button className="button-2" onClick={() => this.AddCart(2, 50)}>+</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    

                </div>

                <div className="grand_total">
                    <h1>Total Items:{this.state.firstCount + this.state.secondCount}</h1>
                    <h1>Grand Total : ₹{this.state.TotalPrice}</h1>
                </div>
            </>
        )
    }
}

export default Cards;
